import { useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import logo from "../../../../../Assets/images/logo.png";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import GuardianDetailRow from "components/shared/Cllients/GuardianDetailRow";
import { useCreateIntakeReportMutation, useGetHomeEducationClientDetailsQuery, useGetIntakeTemplateQuery } from "store/services/clients/homeEducation.client";
import { CalendarIcon } from "Assets/icons";
import { dateFormat, getAge } from "helpers/common";
import { Formik } from "formik";
import { INTAKE_TEAM_EMAIL } from "config/constants";
import { useUploadFileMutation } from "store/services/utility";
import LoadingButton from "components/shared/LoadingButton";
import { pdf } from "@react-pdf/renderer";
import { IntakeReportDoc } from "components/PDF/Clients/Reports/IntakeReportPDF";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import { reportQuestionsValidationSchema } from "utils/validation/validationHelpers";
import { object } from "yup";
import RenderQuestion from "components/shared/ReportComponents/Questions/Index";
import { VIEW_HOME_EDUCATION } from "config/paths";
import { isEmpty } from "lodash";
import KhanReportLogo from "components/shared/KhanReortLogo";

const IntakeReport = () => {
  const { id: clientId } = useParams();
  const navigate = useNavigate();

  const [preview, setPreview] = useState(false);

  // get client details
  const { data, isLoading, refetch, isFetching } = useGetHomeEducationClientDetailsQuery(clientId);

  // get intake report template
  const { data: intakeQuestions, isLoading: templateLoading } = useGetIntakeTemplateQuery();

  // create intake report
  const [createReport, { isLoading: createReportLoading }] = useCreateIntakeReportMutation();

  // file upload api
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();

  const validationSchema = useMemo(() => {
    if (!intakeQuestions) return object();

    return reportQuestionsValidationSchema(intakeQuestions);
  }, [intakeQuestions])

  const handleSubmit = async (values) => {
    try {
      const doc =
        <IntakeReportDoc
          data={data}
          answers={values}
          questions={intakeQuestions}
        />

      const asPdf = pdf([]);
      asPdf.updateContainer(doc);
      const blob = await asPdf.toBlob();
      const fileToUpload = new File([blob], "intake_report.pdf", { type: blob.type });

      let uploadedFileName = await uploadFile({ file: fileToUpload, acl: "private" }).unwrap();

      if (!uploadedFileName) {
        throw new Error("File not uploaded");
      }

      const payload = {
        clientId,
        data: {
          "attachment_key": uploadedFileName,
          "attachment_name": uploadedFileName,
        }
      }

      await createReport(payload).unwrap();
      navigate(generatePath(VIEW_HOME_EDUCATION, { id: clientId }));
    } catch (err) {
      console.error("Error saving reference letter:", err);
    }
  }

  return (
    <>
      <section className="referenceLetter position-relative py-2">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-lg-5 p-3 rounded shadow">
                <div className="top text-center">
                  <img src={logo} alt="" className="img-fluid" />
                </div>
                {(isLoading || templateLoading) ? (
                  <LoadingIndicator />
                ) : (data && intakeQuestions) ? (
                  <Formik
                    initialValues={{}}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize
                  >
                    {({ handleSubmit, values, errors, isValid, isSubmitting, touched }) => (
                      <Form onSubmit={handleSubmit}>
                        {console.log("error", errors)}
                        <Row>
                          <Col lg="" className="my-2">
                            <div
                              className="formDetail rounded"
                              style={{ background: "#F9F9F9" }}
                            ></div>
                          </Col>
                          <Col lg="12" className="my-2">
                            <div
                              className="cardCstm rounded-2 px-3"
                              style={{ background: "#F9F9F9" }}
                            >
                              <Row className="border-bottom p-2">
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      Last Name
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      {data?.lastname}
                                    </p>
                                  </div>
                                </Col>
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      First Name
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      {data?.firstname}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="border-bottom p-2">
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      Birth Date:
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      <span className="icn me-2">
                                        <CalendarIcon />
                                      </span>
                                      {dateFormat(data?.client_detail?.dob)}
                                    </p>
                                  </div>
                                </Col>
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      Chronological Age:
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      {getAge(data?.client_detail?.dob)}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                              {data?.client_detail?.client_guardian_mapping?.length > 0 &&
                                data?.client_detail?.client_guardian_mapping?.map(
                                  (guardian, index) => {
                                    const slug = guardian?.client_guardian?.client_role?.slug;
                                    if (slug !== "parent") {
                                      return null;
                                    }

                                    return (
                                      <GuardianDetailRow
                                        index={index}
                                        guardian={guardian}
                                        slug={slug}
                                      />
                                    );
                                  }
                                )}
                              <Row className="border-bottom p-2">
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      Date of Intake:
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      <span className="icn me-2">
                                        <CalendarIcon />
                                      </span>
                                      {dateFormat(data?.client_detail?.client_home_education_detail?.intake_date)}
                                    </p>
                                  </div>
                                </Col>
                                <Col md="6" className="py-2">
                                  <div className="d-flex align-items-start gap-10 flex-wrap">
                                    <h6
                                      className="m-0 fw-sbold themeBlue"
                                      style={{ minWidth: 200, fontSize: 14 }}
                                    >
                                      Grade:
                                    </h6>
                                    <p className="m-0 forteen themeBlue">
                                      {data?.client_detail?.grade}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          {/* {intakeQuestions?.length > 0 && intakeQuestions.map((question, index) => (
                            <Col key={index} md="12" className="my-2">
                              <h6 className="m-0 themeBlue fw-bold pb-2">
                                {question?.question}
                              </h6>
                              <AppInputField
                                fieldType={"textarea"}
                                name={question.id}
                                rows={5}
                                className="form-control rounded-4 h-auto bg-white py-2"
                                placeholder="Indicate who was present in the meeting, and verify that the parent is teaching all the curriculum. Confirm that the student is not in an online program and does not receive education from teachers.   Indicate what concerns the parent has, and what previous services the family has accessed.  Indicate whether or not the parent qualifies for any services through the home education program at this time. If they student qualifies, indicate how the parent’s concerns will be addressed."
                              />
                            </Col>
                          ))} */}
                          {intakeQuestions?.length > 0 &&
                            intakeQuestions?.map((question, index) => {
                              return (
                                <Col key={index} md="12" className="my-2">
                                  <RenderQuestion
                                    preview={preview}
                                    question={question}
                                    fieldName={question.id}
                                  />
                                </Col>
                              );
                            }
                            )}
                          <Col md="12" className="my-2">
                            <p style={{ fontSize: "16px" }} className="m-0">
                              The intake team may be contacted at: <a className="themeClr" href={`mailto:${INTAKE_TEAM_EMAIL}`}>{INTAKE_TEAM_EMAIL}</a>
                            </p>
                          </Col>
                          <Col md="12" className="my-2 mt-5">
                            <KhanReportLogo />
                          </Col>

                          <Col lg="12" className="my-2 mt-5">
                            {/* {data && (
                              <BlobProvider document={<IntakeReportDoc data={data} answers={values} questions={intakeQuestions} />}>
                                {({ blob, url, loading, error }) => {
                                  return (
                                    loading ? 'Loading document...' : (
                                      <div className={`pt-4 btnWrpper`}>
                                        <LoadingButton
                                          // type="submit"
                                          className="d-flex align-items-center justify-content-center w-100 commonBtn"
                                          onClick={() => {
                                            window.open(url)
                                          }}
                                        >
                                          Open pdf
                                        </LoadingButton>
                                      </div>
                                    )
                                  )
                                }}
                              </BlobProvider>
                            )} */}
                            <div className="d-flex">
                              <Button
                                type="button"
                                className="d-flex align-items-center justify-content-center commonBtn"
                                onClick={() => {

                                  if (isEmpty(errors)) {
                                    setPreview(!preview);
                                  }
                                }}
                              >
                                {preview ? "Edit" : "Preview"}
                              </Button>
                              {preview && <LoadingButton
                                type="submit"
                                className="d-flex align-items-center justify-content-center commonBtn mx-2"
                                isLoading={isSubmitting}
                              >
                                Save
                              </LoadingButton>
                              }
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <ErrorComponent />
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default IntakeReport;
